import { gql } from 'apollo-angular';

export var participants_search_people = gql`
  query participantsSearchPeople(
    $searchLike: String!
     $role: Mixed
     $search: String!
  ) {

    participant_people(
        first: 8
        name: $searchLike
        orderByInstr: [{ column: NAME, search: $search, order: ASC }]
        hasRole: { column: NAME, operator: LIKE, value: $role }
    ) {
        data {
          id
          name
          user {
            active
          }
        }
    }
    participant_orgs(
        first: 8
        name: $searchLike
        orderByInstr: [{ column: NAME, search: $search, order: ASC }]
        hasRole: { column: NAME, operator: LIKE, value: $role }
    ) {
        data {
          id
          name
          entity {
            entity_types {
              id
              type {
                name
                tagType {
                  id
                  name
                }
              }
            }
          }
        }
    }
    participant_sponsors(
      first: 8,
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ){
      data {
        id
        name
      }
    }


  }
`;
